/* sm-spjall.js: á síma er spjallhnappurinn (Shopify Inbox) falinn þar til skrunað er um nær einn skjá, svo hann
   liggi ekki yfir leitartakka og hnöppum í hero. CSS: assets/sm-type-scale-global.css (html[data-sm-spjall="felt"]).
   Stuttar síður (undir 1,6 skjáhæðum) fela hann aldrei. Bili JS helst hnappurinn sýnilegur eins og áður. */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  var rot = document.documentElement;
  var sima = window.matchMedia('(max-width: 767px)');
  var bid = false;
  function meta() {
    bid = false;
    var vh = window.innerHeight || 0;
    var y = window.pageYOffset || 0;
    var stutt = rot.scrollHeight < vh * 1.6;
    var korfa = !!document.querySelector('.cart-sheet.open'); /* P2-A 23.10: hringurinn ofan á Halda áfram / Loka í Bætt í körfu glugganum */
    var fela = sima.matches && (korfa || (!stutt && y < vh * 0.9));
    if (fela) rot.setAttribute('data-sm-spjall', 'felt');
    else rot.removeAttribute('data-sm-spjall');
  }
  function bidja() { if (!bid) { bid = true; window.requestAnimationFrame(meta); } }
  window.addEventListener('scroll', bidja, { passive: true });
  window.addEventListener('resize', bidja);
  window.addEventListener('load', bidja);
  var blad = document.querySelector('[data-sm-cart-sheet]');
  if (blad && window.MutationObserver) new MutationObserver(bidja).observe(blad, { attributes: true, attributeFilter: ['class'] });
  meta();
})();
